export default __webpack_public_path__ + "static/media/co-curriculars.146114d4.svg";